export default {
    type: 'Tipo',
    'bond-no': 'Número de bono',
    'start-date': 'De fecha',
    'end-date': 'Hasta fecha',
    'bond-status': 'Estado de bono',
    'refresh': 'Actualizar',
    all: 'Todo',
    'posted': 'Publicado',
    'non-posted': 'No Publicado',
    'cash': 'Efectivo',
    'accounting': 'Contabilidad',
    'total-count': 'Número total',
    'non-posted-bonds-count': 'Número de bonos no publicado',
    'delete-bond': 'Eliminar fila',
    'do-you-want-to-delete-$-bond-with-no-$': '¿Desea eliminar el diario {type} con el número {no}?',

    'right-click-menu-items': {
        'go-to-the-journal': 'Ir al diario',
        delete: 'Eliminar',
    },

    headers: {
        'serial': 'Serial',
        'bond-no': 'Número de bono',
        'type': 'Tipo',
        'status': 'Estado',
        'date': 'Fecha',
    }
}